module.exports = __webpack_public_path__ + "img/sv115.c4ed57ce.svg";